import { useRef, useEffect, EffectCallback, DependencyList } from 'react';

const usePrevious = (value: DependencyList, initialValue: DependencyList) => {
  const ref = useRef(initialValue);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useEffectDebugger = (
  effectHook: EffectCallback,
  dependencies: DependencyList,
  dependencyNames: string[] = []
) => {
  const previousDeps = usePrevious(dependencies, []);

  const changedDeps = dependencies.reduce<
    Record<string, { after: unknown; before: unknown }>
  >((result, dependency, index) => {
    if (dependency !== previousDeps[index]) {
      const keyName = dependencyNames[index] || index;

      return {
        ...result,
        [keyName]: {
          after: dependency,
          before: previousDeps[index],
        },
      };
    }

    return result;
  }, {});

  if (Object.keys(changedDeps).length) {
    console.log('[use-effect-debugger] ', changedDeps);
  }

  useEffect(effectHook, dependencies);
};
